import { render, staticRenderFns } from "./About.vue?vue&type=template&id=30b3e5e2&scoped=true&"
import script from "./About.vue?vue&type=script&lang=ts&"
export * from "./About.vue?vue&type=script&lang=ts&"
import style0 from "./About.vue?vue&type=style&index=0&id=30b3e5e2&prod&scoped=true&lang=css&"
import style1 from "./About.vue?vue&type=style&index=1&id=30b3e5e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3e5e2",
  null
  
)

export default component.exports